module.exports = __webpack_public_path__ + "static/Image05@2x-1aeee38087e163cc16f17e810780d201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image05@2x.jpg
// module id = 898
// module chunks = 227233210825294 244429959259914